import { fetchUnsettledSecuritiesPosition3 } from '@/api/business/unsettledSecurities'
import { useQuery } from '@tanstack/react-query'

export const UnsettledSecuritiesPosition3Keys = {
    all: ['unsettledsecuritiesposition3'] as const,
    lists: () => [...UnsettledSecuritiesPosition3Keys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...UnsettledSecuritiesPosition3Keys.lists(), page, perPage, filters] as const,
    details: () => [...UnsettledSecuritiesPosition3Keys.all, 'detail'] as const,
    detail: (params: string) => [...UnsettledSecuritiesPosition3Keys.details(), params] as const,
}

export const useUnsettledSecuritiesPosition3Query = () => {
    return useQuery({
        queryFn: fetchUnsettledSecuritiesPosition3,
        queryKey: UnsettledSecuritiesPosition3Keys.lists(),
    })
}
